import { ZoomIn } from "../../components/Transitions/ZoomIn";

export const Intro = () => {
  return (
    <section className="relative min-h-svh w-full overflow-hidden bg-secondary-light">
      <div className="hero-bg absolute inset-0 bg-[url(/public/hero_mob.jpeg)] bg-cover bg-center bg-no-repeat md:bg-[url(/public/1.png)] md:bg-cover md:bg-top" />
      <div className="hero-content relative flex min-h-svh items-start md:items-center justify-center  py-16 md:justify-start md:px-12 lg:px-20">
        <div className="w-full max-w-3xl text-center text-primary-text md:text-left pt-16 md:pt-0">
          <div className="hero-title mx-auto md:max-w-2xl md:rounded-4xl px-6 py-8 md:mx-0 md:px-10 md:py-10">
            <div className="relative z-2">
              <ZoomIn>
                <div className="eyebrow-hero mb-4">1 Noviembre 2026</div>
                <div className="text-3xl md:text-4xl">¡Nos casamos!</div>
                <div className="font-script mt-3 text-5xl leading-none md:text-7xl">
                  Natalia y David
                </div>
                <div className="mt-5 text-base font-semibold tracking-[0.24em] uppercase md:text-md">
                  Sevilla, España
                </div>
              </ZoomIn>
              <div className="hero-title-blur"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
